/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xml_Feed_Key_RotatedInputs */

const cs_xml_feed_key_rotated = /** @type {(inputs: Xml_Feed_Key_RotatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klíč feedu obnoven`)
};

const en_xml_feed_key_rotated = /** @type {(inputs: Xml_Feed_Key_RotatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feed key rotated`)
};

/**
* | output |
* | --- |
* | "Feed key rotated" |
*
* @param {Xml_Feed_Key_RotatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const xml_feed_key_rotated = /** @type {((inputs?: Xml_Feed_Key_RotatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xml_Feed_Key_RotatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xml_feed_key_rotated(inputs)
	return cs_xml_feed_key_rotated(inputs)
});